// extracted by mini-css-extract-plugin
module.exports = {"root":"root_12UcHgrQU9","formControls":"formControls_UoB1ONqIeP","result":"result_2IndSnM8fT","resultIcon":"resultIcon_3Vzq-SxqzM"};